<template>
  <b-card class="m-2 black-box-secondary bg-light text-left tra">
    <b-card-text>
      <b-row>
        <b-col md="8">
          <span style="font-weight: 600">{{ nomeTipo }}</span>
        </b-col>
        <b-col md="4" class="bottoni">
          <div class="rounded-pill bg-white text-center p-2" style="text-transform: uppercase">
            <span class="flag">{{ item.src_language.flag }}</span>
            {{ item.src_language.id }}
            <b-icon icon="chevron-right" font-scale="1" class="mx-2"></b-icon>
            <span class="flag">{{ item.dest_language.flag }}</span>
            {{ item.dest_language.id }}
            <b-icon-music-note
              v-if="item.request_audio"
              title="E' richiesta anche la lettura audio"
              v-b-tooltip.hover
            ></b-icon-music-note>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8">
          <a @click="showNote(item.note)" class="text-primary" v-if="item.note" href="#"> Note </a><br />
          Richiesta da
          <b-avatar
            size="1.5rem"
            :text="`${item.requester.first_name.substr(0, 1)} ${item.requester.last_name.substr(0, 1)}`"
          ></b-avatar>
          {{ item.requester.organization }}
          <div v-if="item.due_date">
            <span v-if="!item.delivery_date"> Desiderata: {{ item.due_date | moment("DD/MM/YYYY") }} </span>
            <span v-if="item.delivery_date"> Consegna: {{ item.delivery_date | moment("DD/MM/YYYY") }} </span>
          </div>
        </b-col>
        <b-col md="4" class="bottoni">
          <br />
          <b-button
            pill
            @click.prevent="download(`${item.id}/original/${item.name}`)"
            title="Scarica Documento Originale"
            variant="outline-primary"
            class="btn-circle mr-2"
            v-b-tooltip.hover
          >
            <b-icon-file-earmark></b-icon-file-earmark>
          </b-button>
          <b-button
            pill
            @click.prevent="download(`${item.id}/translated/${item.name}`)"
            title="Scarica Traduzione Automatica"
            variant="outline-secondary"
            class="btn-circle mr-2"
            v-b-tooltip.hover
            v-if="isAutoTranslatable(this.item)"
          >
            <b-iconstack>
              <b-icon stacked icon="chat" variant="secondary"></b-icon>
              <b-icon stacked icon="gear" variant="secondary" shift-v="-3" shift-h="2" scale="0.60"></b-icon>
            </b-iconstack>
          </b-button>
          <b-button
            pill
            variant="outline-info"
            @click="uploadModal(item.id)"
            v-if="!item.delivery_date"
            class="btn-circle mr-2"
            title="Carica revisione aggiornata"
            v-b-tooltip.hover
          >
            <b-icon-arrow-up-circle></b-icon-arrow-up-circle>
          </b-button>

          <b-button
            pill
            variant="outline-info"
            @click="audioModal(item.id)"
            v-if="!item.delivery_date"
            title="Carica traduzione audio"
            class="btn-circle mr-2"
            v-b-tooltip.hover
          >
            <b-icon-mic></b-icon-mic>
          </b-button>

          <b-button
            pill
            @click.prevent="download(`${item.id}/reviewed/${item.name}`)"
            variant="info"
            v-if="item.delivery_date"
            class="btn-circle mr-2"
            title="Scarica Documento Tradotto"
            v-b-tooltip.hover
          >
            <b-icon-file-earmark-check></b-icon-file-earmark-check>
          </b-button>
          <b-button
            pill
            @click.prevent="download(`${item.id}/audio/${item.name}`)"
            variant="success"
            v-if="item.delivery_date && isAudio"
            class="btn-circle mr-2"
            title="Scarica Traduzione Audio"
            v-b-tooltip.hover
          >
            <b-icon-music-note></b-icon-music-note>
          </b-button>

          <b-button
            pill
            variant="outline-secondary"
            @click="uploadModal(item.id)"
            v-if="item.delivery_date"
            title="Carica Revisione Aggiornata"
            v-b-tooltip.hover
            class="btn-circle mr-2"
          >
            <b-icon-file-earmark-arrow-up></b-icon-file-earmark-arrow-up>
          </b-button>
          <b-button
            pill
            variant="outline-secondary"
            @click="audioModal(item.id)"
            v-if="item.delivery_date"
            title="Aggiorna Traduzione Audio"
            v-b-tooltip.hover
            class="btn-circle mr-2"
          >
            <b-icon-mic></b-icon-mic>
          </b-button>
        </b-col>
      </b-row>
    </b-card-text>
  </b-card>
</template>

<script>
import "vue2-datepicker/locale/it";
import util from "@/mixing/util";

export default {
  name: "document",
  mixins: [util],
  props: ["item"],
  data() {
    return {};
  },
  methods: {
    uploadModal(id) {
      this.$parent.uploadModal(id);
    },
    audioModal(id) {
      this.$parent.audioModal(id);
    },
    showNote(note) {
      this.$bvModal.msgBoxOk(note, { title: "Note del Richiedente" });
    },
  },
  computed: {
    isAudio: function () {
      return this.item.audio_exists;
    },
  },
};
</script>
<style></style>
